// @flow
import { values, get } from 'lodash/object'
import { flatten } from 'lodash/array'
import { find } from 'lodash/collection'
import i18n from 'i18next'

import products from '../products'

const flattenProducts = flatten(values(products))

export const getCategoryFromProductID = (productID: number) => {
  const activeProduct = find(flattenProducts, (product) => i18n.t(product.productID) === productID)
  return get(activeProduct, 'type')
}
